import { render, staticRenderFns } from "./selectStatus.vue?vue&type=template&id=58a1c61c&scoped=true&"
import script from "./selectStatus.vue?vue&type=script&lang=js&"
export * from "./selectStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a1c61c",
  null
  
)

export default component.exports